import { Tenant } from 'common/tenant'

// @ts-ignore
const DEV = global.__DEV__
  ? // @ts-ignore
    global.__DEV__
  : // @ts-ignore
  typeof __DEV__ === 'undefined'
  ? false
  : // @ts-ignore
    __DEV__

export const Constants = {
  E2E: DEV && false,
  E2E_NAMESPACE: null,
  REQUEST_TIMEOUT: 10000,
  companyInformation: {
    abn: '88 682 116 114',
    acn: '682 116 114',
    address1: 'The Hoxton Mix',
    address2: '66 Paul Street',
    address2Au: 'Level 10, 387 George Street',
    address3Au: '',
    city: 'London',
    cityAu: 'Sydney',
    company_number: '07212205',
    email: 'help@hoxtonmix.com',
    emailAu: 'help-au@hoxtonmix.com',
    facebook: 'https://www.facebook.com/hoxtonmix/',
    ico_number: 'ZA041914',
    instagram: 'https://www.instagram.com/hoxtonmix/',
    linkedin: 'https://www.linkedin.com/company/hoxton-mix/',
    mlr_number: '12883542',
    name: 'Hoxton Mix',
    phone: '+44 (0)20 347 53374',
    phoneAu: '+61 2 8530 0437',
    phone_full: '020 3475 3374',
    postal_code: 'EC2A 4NA',
    postal_codeAu: 'NSW 2000',
    twitter: 'https://twitter.com/hoxtonmix',
    twitter_handle: '@hoxtonmix',
  },
  defaultLocale: 'en-gb',
  events: {},
  location: (tenant: Tenant) =>
    tenant === Tenant.AU
      ? {
          city: 'Sydney',
          country: 'Australian',
          postcode: 'NSW 2000',
          street: 'George Street',
        }
      : {
          city: 'London',
          country: 'UK',
          postcode: 'EC2A',
          street: 'Paul Street',
        },
  simulate: __DEV__
    ? {}
    : {
        FORCE_LANGUAGE: '',
      },
}

// Full office address, built from companyInformation so it's only defined once
export const getFullAddress = (tenant: Tenant) => {
  const c = Constants.companyInformation
  return tenant === Tenant.AU
    ? `${c.address2Au}, ${c.cityAu}, ${c.postal_codeAu}`
    : `${c.address2}, ${c.city}, ${c.postal_code}`
}
